/* eslint-disable @typescript-eslint/naming-convention */
import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit'
import { withLoadingReducer } from 'utils/reducerHandler'
import {
  GetDirectPutawayDetailResponseType,
  GetDirectPutawayItemByTaskIdResponseType,
  GetDirectPutawayItemByTaskIdParamsType,
} from 'features/PurchaseOrder/services/directPutaway'
import {
  SLICE_NAME,
  fetchDeleteDirectPutawayUnassignStaff,
  fetchGetDirectPutawayDetail,
  fetchGetDirectPutawayItemByTaskId,
} from './thunk'

export type DirectPutawayStateType = {
  isLoading: boolean
  query: GetDirectPutawayItemByTaskIdParamsType
  pagination: {
    page_size: number
    page_index: number
  }
  detail: GetDirectPutawayDetailResponseType['data'] | null
  data: GetDirectPutawayItemByTaskIdResponseType['data']
}

const initialState: DirectPutawayStateType = {
  isLoading: false,
  query: {
    'pagination.page_index': 1,
  },
  pagination: {
    page_size: 20,
    page_index: 1,
  },
  data: [],
  detail: null,
}

const directPutawayDetailSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: withLoadingReducer(
    (builder: ActionReducerMapBuilder<DirectPutawayStateType>) => {
      builder
        .addCase(fetchGetDirectPutawayItemByTaskId.pending, (state, action) => {
          state.query = {
            ...state.query,
            ...action.meta.arg.params,
          }
        })
        .addCase(fetchGetDirectPutawayItemByTaskId.fulfilled, (state, action) => {
          const {
            data,
            pagination: { page_index, page_size },
          } = action.payload

          state.data = data
          state.pagination = {
            page_size,
            page_index,
          }
        })
        // =====
        .addCase(fetchGetDirectPutawayDetail.fulfilled, (state, action) => {
          state.detail = action.payload
        })
    },
    [
      fetchGetDirectPutawayDetail,
      fetchGetDirectPutawayItemByTaskId,
      fetchDeleteDirectPutawayUnassignStaff,
    ],
  ),
})

export const { reset } = directPutawayDetailSlice.actions
export default directPutawayDetailSlice.reducer
